import { Map } from 'immutable';
import {
  LOAD_COMPANIES,
  LOAD_PAGES,
  CHANGE_PAGE,
  GET_PAGE,
  CHANGE_SORT,
  SET_COMPANY,
  GET_COMPANY,
  GET_EXCEL
} from '../actions/companies';


const initialState = Map({
  list: [],
  page: 1,
  pages: 1,
  sort: [],
  company: null
});

const actionsMap = {
  [GET_EXCEL]: (state, action) => {
    return null;//state.get('excel',action.excel);
  },
  [LOAD_COMPANIES]: (state, action) => {
    return state.set('list', action.companies);
  },
  [LOAD_PAGES]: (state, action) => {
    return state.set('pages', action.pages);
  },
  [CHANGE_PAGE]: (state, action) => {
    return state.set('page', action.page);
  },
  [GET_PAGE]: (state) => {
    return state.get('page');
  },
  [GET_COMPANY]: (state) => {
    return state.get('company');
  },
  [SET_COMPANY]: (state, action) => {
    return state.set('company', action.company);
  },
  [CHANGE_SORT]: (state, action) => {
    return state.set('sort', action.sort);
  }
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}


// WEBPACK FOOTER //
// ./reducers/companies.js